<div>
  <div>
    <h4>{{ 'Doc::CustomerCreditNote:Preview' | abpLocalization }}</h4>
  </div>
  <ag-grid-angular
    style="width: 100%"
    class="ag-theme-digiwall"
    domLayout="autoHeight"
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    [treeData]="true"
    [getDataPath]="getDataPath"
    #grid
    [getRowClass]="getRowClass"
  >
  </ag-grid-angular>
</div>
